export const getDefaultLanguage = () => {
  return navigator.language.split(/[-_]/)[0] // language without region code
}

export const reloadPage = (navigate: any) => {
  navigate(0)
}
